export const ACOUSTIC_CONSTANTS = {
  SPEED_OF_SOUND_MPS: 343.2,
  CANVAS_TO_METERS_RATIO: 0.1,
  MIN_AUDIBLE_DISTANCE: 1.5,
  MAX_AUDIBLE_DISTANCE: 80.0,
};

export default ACOUSTIC_CONSTANTS;
